<template>
    <router-link
        tag='div'
        class="workout-video"
        v-if="video"
        @click="gaSelectClass"
        :to="`/treino/${workoutId}/video/${video.slug}`"
    >
        <img :src="thumbnail" class="workout-video__image">
        <div class="workout-video__infos">
            <h4 class="card-title" v-html="$root.getTitle({ ...video, type: 'video-card' })"></h4>
            <p class="workout-video__infos__description">{{ video.description }}</p>
        </div>
    </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: [ 'video', 'workoutId' ],
    data () {
        return {
            thumbnail : `https://img.youtube.com/vi/${this.video.videoId.params.v}/maxresdefault.jpg`
        }
    },
    computed: {
        ...mapGetters(['theme'])
    },
    methods : {
        gaSelectClass () {
            this.$gtm.trackEvent({
                event: 'gaEvent',
                eventCategory: `treine-em-casa-${this.theme}`,
                eventAction: this.video.subtitle,
                eventLabel: '',
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .workout-video {
        border-radius: 10px;
        overflow: hidden;
        background: black;
        display: grid;
        grid-template-rows: 1fr 1fr;
        cursor: pointer;

        @media screen and (min-width: 769px){
            grid-template-rows: 1fr;
            grid-template-columns:  3fr 4fr;
        }

        &:hover {
            background: #222222;
        }

        &__infos {
            padding: 0 10px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            width: 100%;

            @media screen and (min-width: 769px){
                padding: 10px 50px;
            }
        }

        &__image {
            border-radius: 10px;
        }

        /deep/ &__title {
            font-size: 20px;

            @media screen and (min-width: 769px){
                font-size: 25px;
            }
        }
    }
</style>
